import { Component } from '@angular/core';

export class BaseModalComponent {
    // Title that will be shown
    public title: string = '';

    // Text to be displayed on the close button
    public closeButtonText: string = 'terug';

    // Initialze function to be overridden
    public init(args: any) {}

    constructor(...args: any[]) {}
}